import React, { FC } from 'react';
import { MediaType } from '../../../../constants/MediaType';
import { IFileThumbnail } from '../types';
import {
  DocumentThumbnail,
  MusicThumbnail,
  PictureThumbnail,
  SWFThumbnail,
  UndefinedThumbnail,
  VideoThumbnail,
  ZipThumbnail,
} from './Thumbnails';
import { SiteIconThumbnail } from './Thumbnails/SiteIconThumbnail/SiteIconThumbnail';
import { ThreeDThumbnail } from './Thumbnails/ThreeDThumbnail';

const selectFileThumbnailComponent = (mediaType: MediaType): FC<IFileThumbnail> => {
  switch (mediaType) {
    case MediaType.SecurePicture:
    case MediaType.Picture:
    case MediaType.VectorArt:
      return PictureThumbnail;

    case MediaType.SiteIcon:
      return SiteIconThumbnail;

    case MediaType.SecureVideo:
    case MediaType.Video:
      return VideoThumbnail;

    case MediaType.SecureMusic:
    case MediaType.Music:
      return MusicThumbnail;

    case MediaType.ThreeD:
      return ThreeDThumbnail;

    case MediaType.SecureDocument:
    case MediaType.Document:
      return DocumentThumbnail;

    case MediaType.SecureZip:
    case MediaType.Zip:
      return ZipThumbnail;

    case MediaType.SWF:
      return SWFThumbnail;

    default:
      return UndefinedThumbnail;
  }
};

export const FileThumbnail: FC<IFileThumbnail> = (props) => {
  const ThumbnailComponent = selectFileThumbnailComponent(props.file.mediaType);

  return <ThumbnailComponent {...props} />;
};
